"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomPick = void 0;
const randomPick = (arr) => arr[Math.floor(Math.random() * arr.length)];
exports.randomPick = randomPick;
//# sourceMappingURL=randomPick.js.map